// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root_k8v1j","logo":"Header_logo_1oluv","text":"Header_text_3lYga","vlm":"Header_vlm_HbIIj"};